// removed by extract-text-webpack-plugin
module.exports = {"field":"_3d5GoX6UC5uKs3ctHRWp-W"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/RadioField.scss
// module id = 1452
// module chunks = 0